import React, { useEffect, useState } from "react";
import { DonutChart } from "@carbon/charts-react";
function AssetDonutChart({ graphData }) {
  const [colorMap, setColorMap] = useState({});
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(3)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toFixed(2).toString();
    // return num.toString();
  }
  const baseColors = [
    "#26aba4",
    "#e8787d",
    "#f7a452",
    "#9df3f2",
    "#FF00FF",
    "#00FFFF",
    "#808080",
    "#FFA500",
    "#A020F0",
    "#40E0D0",
  ];
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  const formatCenterValue = (value) => {
    return `₹${indianNumberFormat(value)}`;
  };

  const options = {
    title: null,
    toolbar: false,
    tooltip: {
      valueFormatter: (tooltipValue, label) =>
        `${formatToIndianRupees(tooltipValue)}`,
    },
    legend: {
      alignment: "center",
    },

    color: {
      scale: colorMap,
      getFillColor: (dataPoint) => colorMap[dataPoint.group],
    },

    resizable: true,
    donut: {
      center: {
        numberFormatter: formatCenterValue,
        label: "Total Value",
      },
      alignment: "center",
    },
    pie: {
      labels: {
        formatter: () => void 0,
      },
    },
    height: "290px",
  };
  const getColorCycle = (dataLength) => {
    const colors = [];
    for (let i = 0; i < dataLength; i++) {
      colors.push(baseColors[i % baseColors.length]); // Cycle through base colors
    }
    return colors;
  };
  useEffect(() => {
    if (graphData.length > 0) {
      const newColorMap = {};
      const colorCycle = getColorCycle(graphData.length);
      graphData.forEach((item, index) => {
        newColorMap[item.group] = colorCycle[index];
      });
      setColorMap(newColorMap);
    }
  }, [graphData]);
  return (
    <div>
      <div className=" mt-16 ">
        <DonutChart data={graphData} options={options}></DonutChart>
      </div>
    </div>
  );
}

export default AssetDonutChart;
